import React from 'react';
import ReactDOM from 'react-dom';
import './style/main.css';
import Main from './Main';

ReactDOM.render(<Main />, document.getElementById('root'));
// registerServiceWorker();
